<style>
  :host {
    display: inline-block;
    height: fit-content;
    width: fit-content;
    /* Во flex-ряду с длинным названием услуги иконку сжимало (у svg max-width: 100%) */
    flex-shrink: 0;
  }
</style>

@let requestProduct = $requestProduct();
@let requestProductIconName = $requestProductIconName();
@let installedDevices = $installedDevices();

<ng-template #hintTemplate>
  <div class="text-xs">
    {{ 'request_product.service_product' | translate }}
    <b>{{
      requestProduct.requestProductId | entityTranslate: 'request_products'
    }}</b>
  </div>
  <div class="text-xs">
    {{ 'request_product.claimed' | translate }}
    <b>{{ requestProduct.amount }}</b>
  </div>
  @if (installedDevices.length > 0) {
    <div class="text-xs">
      {{ 'request_product.installed_devices' | translate }}
      <b>{{ $installedDevices() | tuiMapper: joinNames }}</b>
    </div>
  }
  <div class="text-xs">
    <b>{{
      $isCompleted()
        ? ('request_product.completed' | translate)
        : ('request_product.not_completed' | translate)
    }}</b>
  </div>
</ng-template>

<div
  class="inline-block w-fit h-fit"
  [class]="
    $withoutPadding()
      ? ''
      : $iconSize() === RequestProductIconSize.Xl
        ? 'pr-3'
        : 'pr-2'
  "
  [tuiHint]="hintTemplate"
  tuiHintAppearance="dark"
>
  <div class="inline-block w-fit h-fit relative x-product">
    @if (requestProductIconName) {
      <x-svg-icon
        icon="x-icon-goods::{{ requestProductIconName }}"
        class="h-fit! w-fit!"
        [class]="`${$state()} icon-${$iconSize()}-size`"
      ></x-svg-icon>
    }
    @if ($withCounter() && requestProduct.amount > 1) {
      <span
        tuiBadge
        appearance="custom"
        class="bg-[#FA7281]! absolute! top-0 border-2! border-solid! border-white! box-border"
        style="transform: translateX(-65%)"
        size="s"
        [style.scale]="$counterScale()"
        >{{ requestProduct.amount }}</span
      >
    }
  </div>
</div>
